// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationPageContainerStyles } from "@steiner/Overrides/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.container = {
    css: css`
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 317px;
        grid-template-rows: auto;
        gap: 12px 22px;
        ${xScreen("lte", "sm")} {
            grid-template-columns: auto;
        }
    `,
};

orderConfirmationPageContainerStyles.leftSection = {
    css: css`
        grid-area: 1 / 1 / 2 / 2;

        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 20px;

        & > div:empty {
            display: none;
        }

        ${xScreen("lte", "sm")} {
            grid-area: 1 / 1 / 2 / 2;
        }
    `,
};

orderConfirmationPageContainerStyles.rightSection = {
    css: css`
        grid-area: 1 / 2 / 2 / 3;
        margin-top: 22px;

        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

orderConfirmationPageContainerStyles.headingSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
};

orderConfirmationPageContainerStyles.title = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

orderConfirmationPageContainerStyles.styledHr = {
    css: css`
        margin-top: 5px;
    `,
};

orderConfirmationPageContainerStyles.mobileRightSection = {
    css: css`
        ${xScreen("gt","md")} {
            display: none;
        }
    `,
};